import { storage } from '@redbubble/persistent-storage';
import { ObjectValues } from 'types';

const load = (key: string): Record<string, any> => {
  const item = storage.getItem(key);
  if (item) {
    return JSON.parse(item);
  }
  return {};
};

const del = (key: string): void => {
  storage.removeItem(key);
};

const store = (key: string, data: Record<string, any>): void => {
  storage.setItem(key, JSON.stringify(data));
};

interface SearchUUIDData {
  searchUUID: string;
  createdAt: string;
}

// Keys to be used with trackGa4AddToCartEvent, to only be usable on client
// typeof check is only added here to ensure that build works on server
// the fallback will never be accessible
export const SearchUUIDStorageKey = {
  Latest: 'latest',
  Referrer: typeof document !== 'undefined' ? document.referrer : 'never',
  LocationPathname:
    typeof window !== 'undefined' ? window.location.pathname : 'never',
} as const;

export type SearchUUIDStorageKeyId = ObjectValues<typeof SearchUUIDStorageKey>;

const searchUUIDStorage = {
  get(url: string): string | undefined {
    const key = `rbs_${url}`;
    const data = load(key) as SearchUUIDData;
    const { searchUUID } = data;
    return searchUUID;
  },
  set(url: string, searchUUID: string): void {
    store(`rbs_${url}`, { searchUUID, createdAt: new Date() });
  },
};

Object.keys(storage.getAllItems()).forEach((key) => {
  if (key.match('rbs_')) {
    const data = load(key) as SearchUUIDData;
    if (data.createdAt) {
      const createdAt = new Date(Date.parse(data.createdAt));
      // advance 30 minutes in the future
      createdAt.setMinutes(createdAt.getMinutes() + 30);
      // if still too old
      if (createdAt < new Date()) {
        del(key);
      }
    }
  }
});

export default searchUUIDStorage;
